import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { LicensingService } from 'identity';
import { LicenseInfoDto } from '../../UvExplorerServer.Dtos.TS/LicenseStats';
import { MessageService as PrimeMessageService} from 'primeng/api';


@Injectable()
export class MessageService {

	private readonly InfoDelay = 3000;	// ms
	private readonly ErrorDelay = 5000;	// ms

	/*private _message: string;
	public get message(): string {
		return this._message;
	}
	public set message(value: string) {
		this._message = value;
		this.messageChanged.next(value);
	}

	private messageChanged: Subject<string>;
	public onMessageChanged: Observable<string>;*/


	private _working: number;
	public get working(): number {
		return this._working;
	}
	public set working(value: number) {
		this._working = value;
		this.workingChanged.next(this._working);
	}
	public startWork(): void {
		//console.log(`startWork(): ${this._working} -> ${this._working + 1}`)
		++this._working;
		this.workingChanged.next(this._working);
	}
	public endWork(): void {
		if (this._working > 0) {
			//console.log(`endWork(): ${this._working} -> ${this._working - 1}`)
			--this._working;
			this.workingChanged.next(this._working);
		}
		else {
			console.error("Ending work when none is going on");
		}
	}

	private workingChanged: Subject<number>;
	public onWorkingChanged: Observable<number>;


	constructor(private licensingService: LicensingService, private messageService: PrimeMessageService) {
		/*this._message = "";
		this.messageChanged = new Subject<string>();
		this.onMessageChanged = this.messageChanged.asObservable();*/

		this._working = 0;
		this.workingChanged = new Subject<number>();
		this.onWorkingChanged = this.workingChanged.asObservable();
	}

	public displayInfoMessage(msg: string, timeout: number = this.InfoDelay): void {
		this.messageService.add({severity:'info', summary:'Info', detail:msg, life:timeout});
	}

	public displayErrorMessage(msg: string, timeout: number = this.ErrorDelay): void {
		let errorMsg = "Error: " + msg;
		this.licensingService.getLicenseInfo().subscribe(
			(result: LicenseInfoDto) => {
				if (result.isLicenseValid) {
					this.messageService.add({severity:'error', summary:'Error', detail:errorMsg, life:timeout});
				}
				else {
					this.messageService.add({severity:'error', summary:'Error', detail:errorMsg + "<br/>*** INVALID LICENSE ***", life:timeout});
				}
			},
			(error?: any) => {
				this.messageService.add({severity:'error', summary:'Error', detail:errorMsg, life:timeout});
			});
	}

	/*public reset(): void {
		this.message = "";
	}*/

}